import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { AccountDispatcher } from '../store';
import {
  LEGACY_SERVICE_REDIRECT_TOKEN_PARAMETER_KEY,
  LegacyRedirectServicesEnum,
  RETURN_URL_KEY,
} from '../account.data';
import { environment } from '../../environments';

@Injectable()
export class RedirectGuard implements CanActivate {
  constructor(private _accountDispatchers: AccountDispatcher) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    /**
     * Legacy redirection handling ¯\_(ツ)_/¯
     */
    const redirectService = route.queryParamMap.get(
      LEGACY_SERVICE_REDIRECT_TOKEN_PARAMETER_KEY
    );

    if (redirectService) {
      switch (redirectService.toLowerCase()) {
        case LegacyRedirectServicesEnum.provisioning:
          this._accountDispatchers.setReturnUrl(
            `${environment.webAppURL}/billing`
          );
          break;
        case LegacyRedirectServicesEnum.billing:
          this._accountDispatchers.setReturnUrl(
            `${environment.webAppURL}/billing/manage-renew`
          );
          break;
        default:
          this._accountDispatchers.setReturnUrl(environment.webAppURL);
      }
    }

    const returnUrl = route.queryParamMap.get(RETURN_URL_KEY);

    if (returnUrl) {
      this._accountDispatchers.setReturnUrl(returnUrl);
    }

    return true;
  }
}
